/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 21/02/2025
 * @update 21/02/2025
 * @file src/components/W17/W17F3102
 */

import { Column } from "devextreme-react/data-grid";
import { Button, Checkbox, Col, Dropdown, Row, Typography } from 'diginet-core-ui/components';
import { makeStyles } from "diginet-core-ui/theme";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../actions/user-actions";
import * as W17F3102Actions from "../../actions/w17/w17F3102/w17F3102-actions";
import Config from "../../config";
import Api from "../../services/api";
import GridContainer from "../common/grid-container/grid-container";
import { Loading } from "../common/loading/loading";

const FormID = 'W17F3102';

const useStyles = makeStyles({
    ellipsis: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    }
});

const initialDataMaster = {
    StrEmployeeID: '',
    StrEmployeeName: '',
    FilterMonth: '',
};

const W17F3102 = (props) => {
    const classes = useStyles();
    const [iPermission, setIPermission] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const [cboEmployeeLoading, setCboEmployeeLoading] = useState(false);
    const [cboFilterMonthLoading, setCboFilterMonthLoading] = useState(false);
    const [dataMaster, setDataMaster] = useState(initialDataMaster);
    const [dataCboEmployee, setDataCboEmployee] = useState([]);
    const [dataCboFilterMonth, setDataCboFilterMonth] = useState([]);
    const [dynamicCol, setDynamicCol] = useState([]);
    const [dataGrid, setDataGrid] = useState([]);

    const isFirstLoad = useRef(false);
    const gridRef = useRef(false);
    const gridContainerRef = useRef(false);

    useEffect(() => {
        loadPermission();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!iPermission) return;
        isFirstLoad.current = true; // Load lần đầu DONE
        loadForm();
        loadCboEmployee();
        loadCboFilterMonth();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission]);

    const loadPermission = () => {
        props.userActions.getPermission(Config.profile.UserID, FormID, (isPer) => {
            setIPermission(isPer);
        })
    };

    const loadCboEmployee = () => {
        setCboEmployeeLoading(true);
        props.W17F3102Actions.loadCboEmployee((error, data) => {
            setCboEmployeeLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboEmployee(data);
            }
        })
    };

    const loadCboFilterMonth = () => {
        setCboFilterMonthLoading(true);
        props.W17F3102Actions.loadCboFilterMonth((error, data) => {
            setCboFilterMonthLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataCboFilterMonth(data);
            }
        })
    };

    const loadForm = () => {
        const { StrEmployeeID: SalesPersionID = '', FilterMonth = '' } = dataMaster;
        const params = {
            SalesPersionID,
            FilterMonth,
        };
        setFormLoading(true);
        props.W17F3102Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                const { columns = [], rows = [] } = data || {};
                setDynamicCol(columns);
                setDataGrid(rows);
            }
        });
    };

    const onExportExcel = () => {
        const { StrEmployeeID: SalesPersionID = '', StrEmployeeName = '', FilterMonth = '' } = dataMaster;
        const params = {
            SalesPersionID,
            FilterMonth
        };
        const data = {
            method: 'PUT',
            headers: Api.headers(),
            body: JSON.stringify(params)
        };
        const url = Config.env.api + '/w17f3102/export';
        fetch(url, data)
            .then(response => {
                let content_dispostion = response.headers.get('Content-Disposition');
                if (content_dispostion) {
                    content_dispostion = content_dispostion ? content_dispostion.split('filename=') : '';
                    return response.blob();
                } else {
                    return response.json();
                }
            }).then((result) => {
                if (!result.code) {
                    const objectURL = URL.createObjectURL(result);
                    const link = document.createElement('a');
                    let line01 = '';
                    let line02 = '';
                    if (!Config.isEmpty(StrEmployeeName)) line01 = '-';
                    if (!Config.isEmpty(FilterMonth)) line02 = '-';
                    link.href = objectURL;
                    link.download = `${Config.lang('Bao_cao_cham_cong')} ${line01} ${StrEmployeeName} ${line02} ${FilterMonth}`;
                    link.click();
                } else {
                    let message = Config.lang('Loi_chua_xac_dinh');
                    switch (result.code) {
                        case 'EXP001':
                            message = Config.lang('Khong_co_du_lieu');
                            break;
                        case 'F4000E007':
                            message = Config.lang('Ban_chua_chon_mau_bao_cao');
                            break;
                        default:
                            message = result.message;
                            break;
                    }
                    Config.popupCore.show('INFO', message);
                }
            }).catch(() => {
                Config.popupCore.show('ERROR', Config.lang('Loi_chua_xac_dinh'));
            });
    };

    const onView = () => {
        loadForm();
    };

    const onChange = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        let objPlus = { [fieldName]: value };
        if (fieldName === 'StrEmployeeID') objPlus = { ...objPlus, StrEmployeeName: e?.data?.EmployeesName || '' };
        setDataMaster({ ...dataMaster, ...objPlus });
    };

    const renderCheckBoxCol = (e) => {
        return <Checkbox
            readOnly
            style={{ margin: 'auto' }}
            className={'display_row align-center'}
            checked={e?.value === 1}
        />;
    };

    const renderMaxWidthColum = (e, maxWidth = 300) => { // default max width 300
        const value = e?.value || '';
        return <div title={value} className={classes.ellipsis}
            {...(Config.typeOf(maxWidth, 'number') ? { style: { maxWidth } } : {})} >{value}</div>
    };

    const handleRenderCol = () => {
        let result = [];
        for (let i = 0; i < dynamicCol.length; i++) {
            let objPlus = {};
            let type = 'varchar';
            const { Alignment = 'left', FieldName = '', Caption = '', DataType = '', Visible = true, Width = 150, IsPermanent } = dynamicCol[i] || {};
            if (DataType) type = ['decimal', 'varchar', 'int', 'datetime'].find(item => DataType.search(item) > -1);
            switch (type) {
                case 'decimal': // Number
                    objPlus = {
                        alignment: 'right',
                        dataType: 'number'
                    };
                    break;
                case 'varchar': // String
                    objPlus = {
                        alignment: 'left',
                    };
                    break;
                case 'datetime': // Ngày
                    objPlus = {
                        dataType: 'date',
                        alignment: 'center',
                        format: 'dd/MM/yyyy',
                        editorOptions: { placeholder: 'DD/MM/YYYY' }
                    };
                    break;
                case 'int': // CheckBox / Toggle...
                    objPlus = {
                        alignment: 'center',
                        cellRender: (e) => renderCheckBoxCol(e)
                    };
                    break;
                default:
                    break;
            }
            if (IsPermanent === 1) objPlus = { // PIN Cột
                ...objPlus,
                fixed: true,
                visibleIndex: null,
                fixedPosition: 'left',
            };
            result.push(<Column key={i}
                dataField={FieldName}
                caption={Caption}
                width={Width}
                alignment={Alignment}
                visible={Visible}
                cellRender={(e) => renderMaxWidthColum(e)}
                {...objPlus}
            />)
        }
        return result;
    };

    const renderGrid = useMemo(() => {
        let column = [];
        if (!Config.isEmpty(dynamicCol)) column = handleRenderCol(dynamicCol);
        const dataSource = dataGrid.map((item, idx) => ({ ...item, STT: idx }))
        return (
            <GridContainer
                reference={ref => (gridRef.current = ref)}
                ref={ref => (gridContainerRef.current = ref)}
                dataSource={dataSource}
                isPer={iPermission}
                loading={formLoading}
                keyExpr={'STT'}
                typePaging={'normal'}
                itemPerPage={30}
                height={Config.getHeightGrid() - 120}>
                {column}
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iPermission, dataGrid, dynamicCol, formLoading]);

    if (!iPermission) return null;
    return (
        <div className='page-container'>
            <Row>
                {formLoading && <Loading />}
                <Col xs={12}><Typography color={'info'} type={'h4'}>{Config.lang('Bao_cao_cham_cong')}</Typography></Col>
                <Col xs={12} sm={6} md={4} lg={4}>
                    <Dropdown
                        clearAble
                        viewType={'outlined'}
                        valueExpr={'EmployeeID'}
                        displayExpr={'EmployeesName'}
                        label={Config.lang('Nhan_vien')}
                        disabled={formLoading}
                        loading={cboEmployeeLoading}
                        value={dataMaster?.StrEmployeeID}
                        dataSource={dataCboEmployee || []}
                        onChange={e => onChange('StrEmployeeID', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={4} lg={4}>
                    <Dropdown
                        clearAble
                        viewType={'outlined'}
                        valueExpr={'FilterMonth'}
                        displayExpr={'FilterMonth'}
                        label={Config.lang('Thang')}
                        disabled={formLoading}
                        loading={cboFilterMonthLoading}
                        value={dataMaster?.FilterMonth}
                        dataSource={dataCboFilterMonth || []}
                        onChange={e => onChange('FilterMonth', e)}
                    />
                </Col>
                <Col xs={12} sm={6} md={4} lg={4} verticalAlign={'end'}>
                    <Button
                        disabled={formLoading}
                        label={Config.lang('Xuat_excel')}
                        viewType={'outlined'}
                        color={'success'}
                        startIcon={'Sheet'}
                        onClick={onExportExcel}
                    />
                    <Button
                        disabled={formLoading}
                        label={Config.lang('Xem')}
                        viewType={'filled'}
                        color={'info'}
                        startIcon={'View'}
                        className={'mgl2x'}
                        onClick={onView}
                    />
                </Col>
                <Col xs={12}>{renderGrid}</Col>
            </Row>
        </div>
    );
}

export default connect(state => null, (dispatch) => ({
    W17F3102Actions: bindActionCreators(W17F3102Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W17F3102);


